import './AppSelect.scss';

import React from 'react';
import Select from 'react-select';

const AppSelect = (props) => {
    const customStyles = {
        container: () => ({}),
        control: () => ({}),
        valueContainer: () => ({}),
        singleValue: () => ({}),
        input: () => ({}),
        indicatorSeparator: () => ({}),
        dropdownIndicator: (provided, state) => ({transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null}),
        menu: (provided) => ({...provided}),
        menuList: () => ({}),
        option: () => ({}),
    };

    return (
        <Select
            className='app-select'
            classNamePrefix='react-select'
            styles={customStyles}
            menuPlacement='auto'
            {...props}
        />
    );
};

export default AppSelect;
